/**
 * App.js - Dispatcher de tenant.
 *
 * Lee TENANT (calculado en src/config/tenant.js a partir de
 * window.location.pathname) y monta AppMet bajo /met o AppQia
 * en el resto de rutas. Cada AppX trae su propio ThemeProvider,
 * sus rutas y sus páginas; el AuthContext y el cliente axios son
 * tenant-aware desde dentro.
 */

import React from 'react';
import { TENANT } from './config/tenant';
import AppQia from './AppQia';
import AppMet from './met/AppMet';

function App() {
  return TENANT === 'met' ? <AppMet /> : <AppQia />;
}

export default App;
